"use client";

import type { FC, PropsWithChildren } from "react";
import { createContext, useContext, useEffect, useState } from "react";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import { isPreviewing } from "@builder.io/sdk-react";

export type BuilderPreviewState = { mode: "live" } | { mode: "authoring"; components: RegisteredComponent[] };

const initialPreviewState: BuilderPreviewState = { mode: "live" };

const BuilderPreviewContext = createContext<BuilderPreviewState>(initialPreviewState);

export const BuilderPreviewProvider: FC<PropsWithChildren> = ({ children }) => {
  const [builderPreviewState, setBuilderPreviewState] = useState<BuilderPreviewState>(initialPreviewState);

  useEffect(() => {
    if (!isPreviewing()) return;

    const enterAuthoringMode = async () => {
      const { customComponents } = await import("../components-registry");

      setBuilderPreviewState({ mode: "authoring", components: customComponents });
    };

    enterAuthoringMode();
  }, []);

  return <BuilderPreviewContext.Provider value={builderPreviewState}>{children}</BuilderPreviewContext.Provider>;
};

export const useBuilderPreview = () => useContext(BuilderPreviewContext);
